import { apiService } from '@shared/services/apiServices';
import type { SubscriptionPlan } from '@/epics/subscriptionManagment/api/viewSubscriptionPlanApiService';

export interface ListAvailableSubscriptionsResponse {
  success: boolean;
  data: SubscriptionPlan[];
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export const listAvailableSubscriptions = async (params?: {
  page?: number;
  limit?: number;
}): Promise<ListAvailableSubscriptionsResponse> => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', String(params?.page ?? 1));
  queryParams.append('limit', String(params?.limit ?? 10));
  queryParams.append('status', 'active');
  queryParams.append('filter_id', 'null');

  const endpoint = `loopay-subscription-management/subscriptions?${queryParams.toString()}`;
  const response = await apiService.getAPI(endpoint);

  if (response.error) {
    return {
      success: false,
      data: [],
      totalCount: 0,
      page: 1,
      limit: params?.limit ?? 10,
      totalPages: 0,
      hasNextPage: false,
      hasPreviousPage: false,
    };
  }

  return response.data as ListAvailableSubscriptionsResponse;
};
